import React, { useEffect } from 'react';

type Props = {};

const HideScroll: React.FC<Props> = () => {
  useEffect(() => {
    document.body.style.overflowY = 'hidden';

    return () => {
      document.body.style.overflowY = 'auto';
    };
  }, []);

  return null;
};

export default HideScroll;
